module.exports = __webpack_public_path__ + "media/images/photo/about_server-13eabd0999fc6f714fca2c8a59328822.png";